import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  listCardContainer: {
    cursor: 'pointer',

    '& .card__icon': {
      margin: '16px ',
      display: 'flex',
      justifyContent: 'center',
    },

    '& .card__title_item': {
      fontSize: theme.app.typography.body.fontSize,
      margin: 16,
      textAlign: 'center',
      fontWeight: 600,
      color: theme.palette.primary.main,
    },

    '& .card__ha': {
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 400,
      color: theme.app.colors.text.secondary,
      margin: '0 16px 8px 0'
    },

    '& .card__tag__ha': {
      display: 'flex',
      width: '100%',
      marginLeft: 'auto'
    },

    '& .card__tag__icon': {
      margin: '0 8px 8px 16px'
    },
  },
}))
